import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IOnboardingCustomerInformation } from './IOnboardingCustomerInformation';
import { Http, Response, Headers } from '@angular/http';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class ClientOnboardingCustomerInfoService {
  private _cociUrl = CONFIGURATION.baseDataBoardingUrl + 'clientonboardingservice/';

  constructor(private _http: Http) { }

  addClientOnboarding(newObj: IOnboardingCustomerInformation) {
    const headers = new Headers();
    
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
    headers.append('Content-Type', 'application/json');
    const content = JSON.stringify(newObj);

    return this._http.post(this._cociUrl + 'addclient', content, {
      headers: headers
    }).map((response: Response) => response.json())
      .catch(this.handleError);
  }

  getAllControlGroups(): Observable<IOnboardingCustomerInformation[]> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'DATA-ONBOARDING-API-CLIENT');
    return this._http.get(this._cociUrl + 'loadallcontrolgroup',{headers:headers})
      .map((response: Response) => response.json().controlGroupData)
      .catch(this.handleError);
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/OnBoardingCustomerInformation/onboardingCustomerInformation.service.ts